import { defineComponent as _defineComponent } from 'vue';
import { useEventListener } from "@vueuse/core";
import { computed, ref, watch } from "vue";
import { Transform } from "@/components/Workflow/Editor/modules/geometry";
import { useWorkflowStores } from "@/composables/workflowStores";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InputCatcher',
    props: {
        transform: null
    },
    setup(__props) {
        const props = __props;
        const { toolbarStore } = useWorkflowStores();
        const inputCatcher = ref();
        const events = ["pointerup", "pointerdown", "pointermove", "pointerleave"];
        const inverseCanvasTransform = computed(() => new Transform()
            .translate([props.transform.x, props.transform.y])
            .scale([props.transform.k, props.transform.k])
            .inverse());
        const style = computed(() => ({
            transform: `matrix(${inverseCanvasTransform.value.matrix.join(",")})`,
        }));
        let lastPosition = [0, 0];
        useEventListener(inputCatcher, [...events], (event) => {
            event.preventDefault();
            event.stopPropagation();
            const position = inverseCanvasTransform.value.apply([event.offsetX, event.offsetY]);
            const catcherEvent = {
                type: event.type,
                position,
            };
            lastPosition = position;
            toolbarStore.emitInputCatcherEvent(event.type, catcherEvent);
        });
        watch(() => toolbarStore.inputCatcherEnabled, () => {
            if (toolbarStore.inputCatcherEnabled) {
                toolbarStore.emitInputCatcherEvent("temporarilyDisabled", {
                    type: "temporarilyDisabled",
                    position: lastPosition,
                });
            }
        });
        return { __sfc: true, props, toolbarStore, inputCatcher, events, inverseCanvasTransform, style, lastPosition };
    }
});
